export default __webpack_public_path__ + "static/media/Snd_c2.185da65a.mp3";